import React from 'react';
import { Button } from 'antd';

import { SAVE_ICON } from '../icons';

/**
 * WHAT THE SCREEN CAN BE SAVED AS (KPR-1642): the saved filter's buttons in
 * the commit slot at the end of the items page's second toolbar row (on a
 * phone, a row of their own under the third).
 *
 * - The applied saved filter has changed (its name shows a dot):
 *   **Update "In flight"** (only for someone who may change that filter: its
 *   author, or a manager for one pinned for everyone), **Save as new** and
 *   **Revert**.
 * - Nothing is applied and there is something to save (a condition, or an
 *   order someone chose): **Save filter**.
 * - Otherwise nothing. The dot is a hint, never a guard: leaving the page does
 *   not ask.
 */
export default function SavedFilterCommit({
	applied = null,
	changed = false,
	mayUpdate = false,
	canSave = false,
	busy = false,
	onUpdate,
	onSaveNew,
	onRevert,
	onSave,
}) {
	if (applied && changed) {
		const name = applied.name || '(untitled filter)';
		return (
			<span className="saved-filter-commit" role="group" aria-label={`Unsaved changes to ${name}`}>
				{mayUpdate ? (
					<Button className="saved-filter-commit__update" loading={busy} onClick={onUpdate} title={`Write what is on screen to "${name}"`}>
						<span className="saved-filter-commit__update-words">Update “{name}”</span>
					</Button>
				) : null}
				<Button className="saved-filter-commit__new" onClick={onSaveNew}>Save as new</Button>
				<Button type="link" className="saved-filter-commit__revert" onClick={onRevert}>Revert</Button>
			</span>
		);
	}
	if (!applied && canSave) {
		return (
			<span className="saved-filter-commit">
				<Button className="saved-filter-commit__save" icon={<SAVE_ICON aria-hidden="true" />} onClick={onSave}>Save filter</Button>
			</span>
		);
	}
	return null;
}
